import React, { useContext, useRef } from "react";
import { CryptoContext } from "./../context/CryptoContext";

import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const PerPage = () => {
  const { setPerPage } = useContext(CryptoContext);
  const selectRef = useRef(null);

  const handleSelectChange = (e) => {
    const val = e.target.value;
    if (val !== 0) {
      setPerPage(val);
    }
  };

  return (
    <form
      className="relative flex items-center font-nunito"
    >
      <label
        htmlFor="perpage"
        className="relative flex justify-center items-center mr-2 font-bold"
      >
        Show Rows
      </label>
      <select
        name="perpage"
        ref={selectRef}
        className= "focus:border rounded-md bg-gray-200 focus:outline-none focus:ring-1 focus:ring-blue h-[30px] text-white"
        onChange={handleSelectChange}
      >
        <option value="100">100</option>
        <option value="50">50</option>
        <option value="20">20</option>
      </select>
    </form>
  );
};



const Pagination = () => {
  let { page, setPage, totalPages, perPage, cryptoData } =
    useContext(CryptoContext);

  const TotalNumber = Math.ceil(totalPages / perPage);

  const next = () => {
    if (page === TotalNumber) {
      return null;
    } else {
      setPage(page + 1);
    }
  };

  const prev = () => {
    if (page === 1) {
      return null;
    } else {
      setPage(page - 1);
    }
  };

  const multiStepNext = () => {
    if (page + 3 >= TotalNumber) {
      setPage(TotalNumber - 1);
    } else {
      setPage(page + 3);
    }
  };

  const multiStepPrev = () => {
    if (page - 3 <= 1) {
      setPage(TotalNumber + 1);
    } else {
      setPage(page - 2);
    }
  };

  if (cryptoData && cryptoData.length >= perPage) {
    return (
      <div className="w-[100%] flex flex-col sm:flex-row sm:justify-between items-center">
        {/* Data provided by CoinGecko */}
        {/* <span className="text-sm mb-2 sm:mb-0 sm:order-1">
          Data provided by{" "}
          <a
            className="text-cyan"
            href="http://www.coingecko.com"
            rel="noreferrer"
            target="_blank"
          >
            CoinGecko
          </a>
        </span> */}

        {/* Pagination numbers */}
        <ul className="flex items-center justify-center sm:justify-start text-md font-bold mt-2 sm:mt-0 sm:order-2 space-x-1">
          <li className="flex items-center">
            <button className="outline-0 hover:text-cyan w-8" onClick={prev}>
              <IoIosArrowBack />
            </button>
          </li>

          {page + 1 === TotalNumber || page === TotalNumber ? (
            <li>
              <button
                onClick={multiStepPrev}
                className="outline-0 hover:bg-gray-200 rounded-lg w-8 h-8 flex items-center justify-center text-lg"
              >
                ...
              </button>
            </li>
          ) : null}

          {page - 1 !== 0 ? (
            <li>
              <button
                onClick={prev}
                className="outline-0 hover:bg-gray-200 rounded-lg w-8 h-8 flex items-center justify-center "
              >
                {page - 1}
              </button>
            </li>
          ) : null}
          <li>
            <button
              disabled
              className="outline-0 rounded-lg w-8 h-8 flex items-center justify-center bg-blue"
            >
              {page}
            </button>
          </li>

          {page + 1 !== TotalNumber && page !== TotalNumber ? (
            <li>
              <button
                onClick={next}
                className="outline-0 hover:bg-gray-200 rounded-lg w-8 h-8 flex items-center justify-center"
              >
                {page + 1}
              </button>
            </li>
          ) : null}

          {page + 1 !== TotalNumber && page !== TotalNumber ? (
            <li>
              <button
                onClick={multiStepNext}
                className="outline-0 hover:bg-gray-200 rounded-lg w-8 h-8 flex items-center justify-center text-lg"
              >
                ...
              </button>
            </li>
          ) : null}

          {page !== TotalNumber ? (
            <li>
              <button
                onClick={() => setPage(TotalNumber)}
                className="outline-0  hover:bg-gray-200 rounded-lg w-8 h-8 flex items-center justify-center"
              >
                {TotalNumber}
              </button>
            </li>
          ) : null}
          <li>
            <button className="outline-0 hover:text-blue w-8 ml-3" onClick={next}>
              < IoIosArrowForward />
            </button>
          </li>
        </ul>

        {/* Per Page input */}
        <div className="mt-5 sm:mt-0 sm:order-3">
          <PerPage />
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default Pagination;
